// Frame 3 — carousel vòng tròn 3D (3D ring). User chốt 2026-08-04: chạy Y HỆT cơ chế của
// products/community/skin-2026-new/assets/community-news.js — vòng ảnh xoay quanh trục dọc, ảnh 2 bên
// KHÔNG billboard mà nghiêng theo mặt vòng (đó là phần "chiều sâu"), ảnh đang xem scale 1 / alpha 1,
// ảnh còn lại scale 0.82 / alpha 0.55, vòng đứng thẳng (ringTilt = 0). Khác bản community đúng 3 điểm:
//   1. vuốt/kéo ngang chuyển slide — và BỎ HẲN nút prev/next (user chốt 2026-08-04);
//   2. autoplay (designer VLTT yêu cầu vòng tự xoay);
//   3. giãn cách vòng 1.22 thay vì 0.95 vì ảnh VLTT vuông hơn ảnh community (xem chú thích RING_SPACING).
// GSAP 2.x: named export TweenMax/Power4 (v3 đổi API sang gsap.set + ease dạng chuỗi) -> package.json ghim "gsap": "^2.1.3".
// jQuery là global từ CDN libraryMainsite, không import.
import { TweenMax, Power4 } from "gsap";

$(function () {
  var $sec = $("#frame3");
  if (!$sec.length) return; // các trang phụ (danhsach/thongtin/xephang) dùng chung bundle nhưng không có frame3

  var $stage = $sec.find(".carousel-stage");
  var $ring = $sec.find(".carousel-ring");
  var $items = $sec.find(".carousel-item");
  var total = $items.length;
  if (!total) return;

  // Chốt viewport 1 lần lúc load — giống cơ chế MS__pc/MS__mb của libraryMainsite (xoay/resize thì reload).
  var isMobile = window.matchMedia(
    "(max-width: 768px) and (orientation: portrait)",
  ).matches;

  // itemW PHẢI trùng width của .carousel-item trong frame3.scss (= ô slide chính của design).
  var itemW = isMobile ? 768 : 931;
  // Đúng số của community. Nới to hơn (2500+) là mất hẳn độ nghiêng "cánh cửa" — ảnh 2 bên trông
  // phẳng lì như dán lên nền, không còn ra chất 3D ring.
  var PERSPECTIVE = isMobile ? 1200 : 1700;
  // 1.0: sát mức 0.95 của community. 1.22 làm vòng "bung" quá rộng — 2 ảnh cuối dạt ra tận mép
  // section trông rời rạc (user phản hồi 2026-08-04).
  var RING_SPACING = 1.0;
  var rY = 360 / total; // 6 slide -> 60°/ảnh, 7 -> 51.4°, 8 -> 45°
  // chord = 2R·sin(π/N) ≈ RING_SPACING·itemW  ->  R = RING_SPACING·itemW / (2·sin(π/N))
  var radius =
    total > 1
      ? (RING_SPACING * itemW) / (2 * Math.sin(Math.PI / total))
      : itemW;

  // Y HỆT community: ringTilt = 0, vòng đứng thẳng. Chiều sâu đến từ chính phối cảnh của vòng
  // (ảnh 2 bên nhìn nghiêng như cánh cửa), không phải từ việc nghiêng vòng.
  var RING_TILT = 0;

  // Đúng 2 con số của community (trước đây bản VLTT để 0.46/0.75 nên ảnh 2 bên nhỏ hơn hẳn).
  var SCALE_IDLE = 0.82;
  var ALPHA_IDLE = 0.55;
  var TWEEN_SEC = 1;
  var AUTOPLAY_MS = 5000;
  var SWIPE_MIN = 45; // px kéo ngang tối thiểu để tính là một lần vuốt chuyển slide

  var index = 0;
  var rotation = 0; // góc xoay tổng của vòng (cộng dồn để không quay ngược cả vòng)
  var timer = null;

  function render() {
    TweenMax.to($ring, TWEEN_SEC, {
      rotationY: rotation,
      ease: Power4.easeOut,
    });

    // Community chỉ tween scale/alpha; vị trí item trên vòng set 1 lần rồi giữ nguyên.
    $items.each(function (i) {
      var active = i === index;
      TweenMax.to($(this), TWEEN_SEC, {
        scale: active ? 1 : SCALE_IDLE,
        autoAlpha: active ? 1 : ALPHA_IDLE,
        ease: Power4.easeOut,
      });
    });

    $items.removeClass("is-active").eq(index).addClass("is-active");
  }

  // Xoay theo chiều NGẮN NHẤT tới slide đích — note designer: click ảnh nhỏ thì nó thay vào ảnh chính.
  function goTo(target) {
    var next = ((target % total) + total) % total;
    var delta = (((next - index) % total) + total) % total;
    if (delta > total / 2) delta -= total;
    index = next;
    rotation -= delta * rY;
    render();
  }

  function startAuto() {
    stopAuto();
    timer = setInterval(function () {
      goTo(index + 1);
    }, AUTOPLAY_MS);
  }

  function stopAuto() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function init() {
    TweenMax.set($stage, { perspective: PERSPECTIVE });
    TweenMax.set($ring, { z: -radius, rotationX: RING_TILT });

    $items.each(function (i) {
      TweenMax.set($(this), {
        rotationY: rY * i,
        z: radius,
        transformOrigin: "50% 50% " + -radius + "px",
        scale: i === index ? 1 : SCALE_IDLE,
        autoAlpha: i === index ? 1 : ALPHA_IDLE,
      });
    });

    $items.eq(index).addClass("is-active");

    // ===== Vuốt/kéo ngang để chuyển slide (user yêu cầu: không chỉ nhấn nút) =====
    // Pointer Events phủ cả chuột lẫn cảm ứng bằng một đường code; trình duyệt không có
    // PointerEvent (Safari cũ) rơi xuống nhánh touch. Vuốt dọc vẫn cuộn trang bình thường nhờ
    // `touch-action: pan-y` khai ở .content.
    var $content = $sec.find(".content");
    var dragX = 0;
    var dragging = false;
    var swiped = false; // true ngay sau một cú vuốt -> bỏ qua click phát sinh kèm theo

    function dragStart(x) {
      dragX = x;
      dragging = true;
      swiped = false;
      stopAuto();
    }

    function dragMove(x) {
      if (!dragging) return;
      var dx = x - dragX;
      if (Math.abs(dx) < SWIPE_MIN) return;
      // Kéo sang TRÁI = vòng đi tới slide kế (ảnh chạy theo tay), kéo phải = lùi lại.
      goTo(index + (dx < 0 ? 1 : -1));
      dragging = false; // một cú vuốt nhảy đúng 1 slide, thả tay mới vuốt tiếp được
      swiped = true;
    }

    function dragEnd() {
      dragging = false;
      startAuto();
    }

    if (window.PointerEvent) {
      $content.on("pointerdown", function (e) {
        dragStart(e.originalEvent.clientX);
      });
      $content.on("pointermove", function (e) {
        dragMove(e.originalEvent.clientX);
      });
      $content.on("pointerup pointercancel pointerleave", dragEnd);
    } else {
      $content.on("touchstart", function (e) {
        dragStart(e.originalEvent.touches[0].clientX);
      });
      $content.on("touchmove", function (e) {
        dragMove(e.originalEvent.touches[0].clientX);
      });
      $content.on("touchend touchcancel", dragEnd);
    }

    // Ảnh/link bên trong vẫn có hành vi kéo mặc định của trình duyệt -> chặn để không nuốt cú vuốt.
    $content.on("dragstart", function (e) {
      e.preventDefault();
    });

    $items.on("click", function (e) {
      // Bấm trúng nút play: KHÔNG can thiệp. Fancybox v4 bỏ qua sự kiện đã bị preventDefault, chặn ở
      // đây là data-fancybox trên nút sẽ không mở được video.
      if ($(e.target).closest(".btn-play").length) return;
      if (swiped) {
        e.preventDefault();
        return;
      } // vừa vuốt xong: đừng chọn nhầm ảnh dưới ngón tay
      var i = $items.index(this);
      if (i === index) return; // ảnh chính: nhường click cho nút play
      e.preventDefault();
      goTo(i);
      startAuto(); // đếm lại chu kỳ auto sau khi user tự chọn
    });
    // Designer yêu cầu "slider auto xoay chuyển lần lượt theo vòng"; dừng khi user đang xem/hover.
    $sec.on("mouseenter", stopAuto).on("mouseleave", startAuto);
    startAuto();
  }

  init();
});
